export default __webpack_public_path__ + "1ef633d3a28d0986f63e78a70178d06d.woff";